export enum Permission {
  Notifications = 'notifications',
  NotificationsAdmin = 'notifications_admin.legacy_permission',
  NotificationsInternalUsers = 'notifications_internal_users.legacy_permission',
}
